"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class TaxAdjustmentReason extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "TaxAdjustmentReason";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/tax-adjustment-reasons"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create adjustment reasons.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("Cannot update adjustment reason.");
  }

  getAdminPath() {
    console.error("Cannot go to an adjustment reason type.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default TaxAdjustmentReason;
